// Widget scripts
import localSubpage from './js/widgetsSubpage/localSubpage.js';

import mainSlideshow from './js/widgets/mainSlideshow.js';
import cardWidget from './js/widgets/cardWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';

import majorSponsors from './js/widgets/majorSponsors.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
import customMapContent from './js/widgets/customMapContent.js';
import seoWidget from './js/widgets/seoWidget.js';
import footerLogos from './js/widgets/footerLogos.js';

// Custom theme scripts
import { classValidation, mainLocalCode } from './js/localjs.js';

// subpage scripts
mainLocalCode();
$(document).ready(function () {
  localSubpage();
});

// Main theme scripts
$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainSlideshow();
    cardWidget();
    multiScheduleFeature();
    majorSponsors();
    sponsorWidgetContainer();
    customMapContent();
  }
  if (!classValidation(subpagePaths.subpageClass)) {
    seoWidget();
    footerLogos('mainThemeFooterLogos', mainThemeFooterLogosOpts);
  }
});
